import React from "react";

function BookingSuccessModal({ booking, onClose }) {
  if (!booking) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-card">

        <h2 style={{ color: "#16a34a" }}>
          🎉 Booking Confirmed
        </h2>

        <hr />

        <p>
          <strong>Reference</strong><br />
          {booking.referenceNumber}
        </p>

        <p>
          <strong>Date</strong><br />
          {new Date(booking.bookingDate).toDateString()}
        </p>

        <p>
          <strong>Time</strong><br />
          {booking.bookingTime}
        </p>

        <button
          className="continue-btn"
          onClick={onClose}
        >
          Close
        </button>

      </div>
    </div>
  );
}

export default BookingSuccessModal;